// progress-indicator.service.ts
import { InspectDatabase } from '../data/database.structure';
import { ObservableLevelsEnum, TaskStatus } from '../data/enums';
import type {
  THeading,
  TScreen,
} from '../data/local-files/progress-indicators'; // ← adjust path
import { InspectionModel } from '../data/types';

export type ProgressStatus = 'not_started' | 'started' | 'complete';

export interface ScreenProgressRow {
  heading: string;
  screen: string;
  type: TScreen['type'];
  breadcrumb: string[];
  status: ProgressStatus;
}

type PathState = 'unset' | 'set' | 'complete';

interface EvalContext {
  heading: THeading;
  screen: TScreen;
  breadcrumb: string[];
  /** present when evaluating list items */
  item?: unknown;
  itemIndex?: number;
}

export class ProgressIndicatorService {
  constructor(
    private db: InspectDatabase,
    private inspection: InspectionModel,
  ) {}

  processScreen({
    screen,
    entityExternalId,
    dataLevel,
    assetExternalId,
    observationsCount,
  }: {
    screen: TScreen;
    entityExternalId: string;
    dataLevel: ObservableLevelsEnum;
    assetExternalId?: string;
    observationsCount?: number;
  }): TaskStatus {
    if (screen.type === 'parent') {
      const childScreens = Object.values(screen.children || {});

      if (childScreens.length === 0) {
        return TaskStatus.notStarted;
      }

      const childScreensStatus = childScreens.map((child) =>
        this.processScreen({
          screen: child,
          entityExternalId,
          dataLevel,
          assetExternalId,
        }),
      );

      if (
        childScreensStatus.every((status) => status === TaskStatus.completed)
      ) {
        return TaskStatus.completed;
      }

      if (
        childScreensStatus.some((status) => status === TaskStatus.inProgress)
      ) {
        return TaskStatus.inProgress;
      }

      return TaskStatus.notStarted;
    }

    const selectedLevel = screen.level || dataLevel;
    var selectedExternalId = entityExternalId;
    if (selectedLevel === ObservableLevelsEnum.asset) {
      selectedExternalId = assetExternalId || entityExternalId;
    }

    // An inspection synced without category types (#10006) has no observations;
    // every screen then correctly reports notStarted.
    const observations = (
      this.inspection.inspectionCategoryTypes[0]?.observations ?? []
    ).filter(
      (obs) =>
        obs.dataLevelId === selectedLevel &&
        obs.entityExternalId === selectedExternalId &&
        obs.value !== '' &&
        obs.value !== 'false' &&
        screen.paths.find((path) => path === obs.observableItem.identifier),
    );

    if (observations.length === 0) {
      return TaskStatus.notStarted;
    }

    if (observationsCount) {
      if (observations.length < observationsCount) {
        return TaskStatus.inProgress;
      } else {
        return TaskStatus.completed;
      }
    }

    if (observations.length > 0) {
      return TaskStatus.completed;
    }

    // const progress = observations.reduce((acc, obs) => {
    //     if (obs.value === 'true' || obs.value === 'complete') {
    //         return acc + 1;
    //     }
    //     return acc;
    // }, 0);

    // if (progress === observations.length) {
    //     return TaskStatus.completed;
    // }

    // if (progress > 0) {
    //     return TaskStatus.inProgress;
    // }

    return TaskStatus.notStarted;
  }
}
